import { AxiosResponse } from "axios";
import { icd10Dto } from "dto/impress/impress.dto";
import { postCoDto, postCoInputDto } from "dto/impress/postCo.dto";
import impressApi from "services/impress.api";

const impressService = {
    getImpressVersion: () => {
        return impressApi.get<{ version: string }>("/app-version");
    },

    postCoordinationV2: (payload: postCoInputDto) => {
        const _payload: postCoInputDto = {
            ...payload,
            resultRenderOption: {
                postCoOnlyLeftRightDatabase: false
            }
        };
        return impressApi.post<postCoInputDto, AxiosResponse<postCoDto>>(
            "/search/post-co",
            _payload
        );
    },
    searchICD10: (term: string) => {
        return impressApi.get<icd10Dto[]>("/search/icd10", {
            params: { term }
        });
    }
};

export default impressService;
